import { useTheme } from '@mui/material/styles';
import { useTranslation } from 'react-i18next';
import Box from '@mui/material/Box';
import Card from '../common/Card';
import Typography from '@mui/material/Typography';
import { SectionSubheading } from '../common/styled/SectionHeading';

const PriceListDetailsInformation = ({ priceListInfo }: { priceListInfo: any }) => {
  const { t } = useTranslation();
  const theme = useTheme();
  return (
    <Card>
      <Box sx={{ mb: 1.5, mt: -1.5 }}>
        <SectionSubheading>{t('priceList.priceListInformation')}</SectionSubheading>
      </Box>

      {/* Custom divider that spans full width */}
      <Box
        sx={{
          height: '2px',
          backgroundColor: theme.palette.dropdown.border,
          mx: '-24px', // Negative margin to override card padding
          mb: 3,
        }}
      />

      <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 10, mb: 2 }}>
        {/* Left Column */}
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'row',
            gap: 10,
            minWidth: 200,
          }}
        >
          <Box sx={{ gap: 2 }}>
            <Typography
              sx={{
                fontWeight: 500,
                color: theme.palette.modal.title,
                fontSize: '16px',
                minWidth: 120,
              }}
            >
              {t('form.customer')}
            </Typography>
            <Typography
              sx={{
                color: theme.palette.modal.title,
                fontSize: '14px',
                fontWeight: 400,
                mt: 1,
              }}
            >
              {priceListInfo.customer}
            </Typography>
          </Box>
          <Box sx={{ gap: 2 }}>
            <Typography
              sx={{
                fontWeight: 500,
                color: theme.palette.modal.title,
                fontSize: '16px',
                minWidth: 120,
              }}
            >
              {t('form.supplier')}
            </Typography>
            <Typography
              sx={{
                color: theme.palette.modal.title,
                fontSize: '14px',
                fontWeight: 400,
                mt: 1,
              }}
            >
              {priceListInfo.supplier}
            </Typography>
          </Box>
          <Box sx={{ gap: 2 }}>
            <Typography
              sx={{
                fontWeight: 500,
                color: theme.palette.modal.title,
                fontSize: '16px',
                minWidth: 120,
              }}
            >
              {t('form.documentId')}
            </Typography>
            <Typography
              sx={{
                color: theme.palette.modal.title,
                fontSize: '14px',
                fontWeight: 400,
                mt: 1,
              }}
            >
              {priceListInfo.documentNb || priceListInfo.documentId || '-'}
            </Typography>
          </Box>
        </Box>

        {/* Right Column */}
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'row',
            gap: 10,
            minWidth: 200,
          }}
        >
          <Box sx={{ gap: 2 }}>
            <Typography
              sx={{
                fontWeight: 500,
                color: theme.palette.modal.title,
                fontSize: '16px',
                minWidth: 120,
              }}
            >
              {t('form.currency')}
            </Typography>
            <Typography
              sx={{
                color: theme.palette.modal.title,
                fontSize: '14px',
                fontWeight: 400,
                mt: 1,
              }}
            >
              {priceListInfo.currency}
            </Typography>
          </Box>
          <Box sx={{ gap: 2 }}>
            <Typography
              sx={{
                fontWeight: 500,
                color: theme.palette.modal.title,
                fontSize: '16px',
                minWidth: 120,
              }}
            >
              {t('form.validityDateRange')}
            </Typography>
            <Typography
              sx={{
                color: theme.palette.modal.title,
                fontSize: '14px',
                fontWeight: 400,
                mt: 1,
              }}
            >
              {priceListInfo.validityDateRange}
            </Typography>
          </Box>
        </Box>
      </Box>
    </Card>
  );
};

export default PriceListDetailsInformation;
